import { InputNumberProps } from 'antd';
import InputPrice from './InputPrice';

interface OwnProps {}

export type Props = InputNumberProps & OwnProps;

export default InputPrice;
